<template>
  <div>
    <span
      class="btn-group btn-group-toggle mr-1 mt-2 mt-md-0 mt-lg-0"
      data-toggle="buttons"
    >
      <label
        v-if="props.all"
        class="btn status btn-outline-secondary btn-sm"
        :class="{
          active: statusParam === 'all' || statusParam === null
        }"
      >
        <input
          type="radio"
          :name="props.attribute"
          value="all"
          :checked="statusParam === 'all'"
          class="filter-input"
        />
        All
      </label>

      <label
        v-for="(value, index) in Object.keys(props.options)"
        :key="index"
        class="btn status btn-outline-secondary btn-sm"
        :class="{
          active:
            statusParam === value ||
            (statusParam === null && value === props.default)
        }"
      >
        <input
          type="radio"
          :name="props.attribute"
          :value="value"
          :checked="statusParam === value"
          class="filter-input"
        />
        {{ dictionary[value] || startCase(value) }}
      </label>
    </span>
  </div>
</template>

<script setup lang="ts">
import startCase from "lodash/startCase";
import { onMounted } from "vue";

const props = defineProps<{
  options: Record<string, number>[];
  attribute: string;
  form: string;
  dictionary: Record<string, string>;
  all: boolean;
  default: string;
}>();

const urlParams = new URLSearchParams(window.location.search);
const statusParam = urlParams.get("status");

onMounted(() => {
  const form = $(`#${props.form}`);
  form.on("click", ".btn", function () {
    $(this).children().first().prop("checked", true);
    form.submit();
  });
});
</script>
